<script lang="ts" setup>
import Modal from '~/components/Modal.vue'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  item: {
    type: Object,
    required: false,
    default: null,
  },
})

const visible = ref<Boolean>(props.visible)

const modalHeader = computed(() => props.item?.source ?? '')

const media = computed(() => {
  return props.item ? props.item.media ?? props.item.mediaUrls ?? [] : []
})

watch(
  () => props.visible,
  (isVisible) => {
    visible.value = isVisible
  }
)
const emit = defineEmits(['handle', 'updated'])

function handle(value: boolean) {
  emit('handle', value)
}
</script>

<template>
  <Modal :visible="visible" :header="modalHeader" size-md @handle="handle">
    <div class="modal-component-body">
      <PreviewGallery v-if="media.length" :media-gallery="media" />
    </div>
  </Modal>
</template>
